export default __webpack_public_path__ + "static/media/IMG_3841 copie.40bbf3dc.jpg";